import React, { useEffect } from 'react'
import { usePageHeaderByKey } from "../hooks/usePageHeaderBykey";
import PublicPageShell from "../components/PublicPageShell";

export const ThankYou = () => {
  const { pageHeader, isLoading } = usePageHeaderByKey("thank-you");
  const data = JSON.parse(sessionStorage.getItem("contactThankYou") || "{}");
  const { preferredTitle, preferredTitleOtherReason, lastName } = data;
  const preferredTitleDisplay =
    preferredTitle === "Other" && preferredTitleOtherReason
      ? preferredTitleOtherReason
      : preferredTitle;

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  if (isLoading) {
    return (
      <div className="flex h-screen justify-center items-center">
        <i className="pi pi-spin pi-spinner text-red-700" style={{ fontSize: '2rem' }}></i>
      </div>
    );
  }

  return (
    <PublicPageShell>
       <div className="flex flex-col justify-center w-full">
        {pageHeader?.h1 ? (
          <h1 className="text-2xl mb-4 text-left font-bold text-black">
            {pageHeader.h1}
          </h1>
        ) : (
          <h1 className="text-2xl mb-4 text-left font-bold text-black">
            THANK YOU
          </h1>
        )}
        {pageHeader?.content ? (
          <div 
            className="text-gray-700 leading-relaxed mb-4 text-sm"
            dangerouslySetInnerHTML={{ __html: pageHeader.content.replace(/\{preferredTitle\}/g, preferredTitleDisplay || '').replace(/\{lastName\}/g, lastName || '') }}
          />
        ) : (
          <>
            <p className="text-gray-700 leading-relaxed mb-4 text-sm">
              Thank you for completing the form, {preferredTitleDisplay} {lastName}.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4 text-sm">We will get back to you as soon as possible.</p>
            <p className="text-gray-700 leading-relaxed mb-4 text-sm" >American Realty Network Team</p>
          </>
        )}
       </div>
    </PublicPageShell>
  )
}
